module.exports = __webpack_public_path__ + "img/jiadian.1ecea698.png";